// Identidade visual do Rock Plus (isolada — não altera as CSS vars globais do admin).
// Cores de gráfico validadas para daltonismo (CVD) sobre card branco.
export const plus = {
  gradient: 'linear-gradient(135deg, #a601de 0%, #0469f6 100%)',
  primary: '#6125e3',
  // mesmo fundo do restante do admin (body/Container em layouts/App/styles.js)
  bg: '#f4f4f2',
  card: '#ffffff',
  text: '#333333',
  muted: '#828f9b',
  border: '#e8e0f5',
  chart: {
    adesoes: '#2ea052',
    cancelamentos: '#c2280f',
    providers: {
      ASAAS: '#6125e3',
      GOOGLE_PLAY: '#2ea052',
      APP_STORE: '#9a3412'
    }
  },
  badge: {
    success: { bg: '#e9f8ee', color: '#1d7a3c' },
    warning: { bg: '#fff4e5', color: '#a96500' },
    danger: { bg: '#fdebe8', color: '#b02a37' },
    neutral: { bg: '#ededf0', color: '#5b6670' }
  }
};

export const providerLabels = {
  ASAAS: 'Cartão (Asaas)',
  GOOGLE_PLAY: 'Google Play',
  APP_STORE: 'App Store'
};

export function formatBRL(value) {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(Number(value) || 0);
}

export function formatDateBR(dateStr) {
  if (!dateStr) return '-';
  const date = new Date(`${dateStr}T00:00:00`);
  if (Number.isNaN(date.getTime())) return dateStr;
  return new Intl.DateTimeFormat('pt-BR').format(date);
}

const MESES_CURTOS = [
  'jan', 'fev', 'mar', 'abr', 'mai', 'jun',
  'jul', 'ago', 'set', 'out', 'nov', 'dez'
];

// "2026-07" -> "jul/26"
export function formatMesCurto(anoMes) {
  const [ano, mes] = String(anoMes).split('-');
  const nome = MESES_CURTOS[Number(mes) - 1];
  return nome ? `${nome}/${ano.slice(2)}` : anoMes;
}
